import React, { useState, useEffect } from 'react';
import API from '../../pages/Api';
import { motion } from 'framer-motion';
import { FaUsers, FaBook, FaWallet } from 'react-icons/fa';

const AdminHome = () => {
    const [stats, setStats] = useState({ users: 0, courses: 0, payments: 0 });
    const user=JSON.parse(localStorage.getItem('user'));
    
    const [userName, setUserName] = useState(user?.name || '');
    
    useEffect(() => {
   
        const name = localStorage.getItem('userName');
        if (name) {
            setUserName(name);
        }

        
        const token = localStorage.getItem('access_token');
        if (token) {
            API.get('dashboard-stats/', {
                headers: { 'Authorization': `Bearer ${token}` }
            })
            .then(res => setStats(res.data))
            .catch(err => console.error(err));
        }
    }, []);

    const statCards = [
        { title: 'TOTAL USERS', count: stats.users, icon: <FaUsers />, color: 'text-emerald-600', bg: 'bg-emerald-50' },
        { title: 'ACTIVE COURSES', count: stats.courses, icon: <FaBook />, color: 'text-sky-600', bg: 'bg-sky-50' },
        { title: 'PENDING PAYMENTS', count: stats.payments, icon: <FaWallet />, color: 'text-amber-600', bg: 'bg-amber-50' },
    ];

    return (
        <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
            <h1 className="text-xl md:text-3xl font-extrabold font-['Poppins'] text-gray-800 mb-8 tracking-wide">
                Welcome back, <span className="text-blue-700">{userName}</span> !!
            </h1>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                {statCards.map((card, idx) => (
                    <motion.div 
                        whileHover={{ y: -5 }}
                        key={idx}
                        className="bg-white p-4 md:p-6 rounded-2xl md:rounded-3xl border border-gray-100 shadow-sm flex items-center gap-6"
                    >
                        <div className={`p-4 rounded-2xl ${card.bg} ${card.color} text-2xl`}>
                            {card.icon}
                        </div>
                        <div>
                            <p className="text-[10px] font-bold text-gray-400 tracking-widest">{card.title}</p>
                            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">{card.count}</h2>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default AdminHome;